import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";
import { useSelector } from "react-redux";
import InternationalTransferFooterButtons from "./InternationalTransferFooterButtons";
import { decodeHtmlEntities } from "../../../../util/utilfunctions/utilFunctions";

function InternationalTransferSummary({
  transferDetails,
  type,
  handleReturn,
  service,
  user,
  handleContinue,
  isReceipt,
  handleSaveContact,
  contactButtonText,
  disableSaveContact,
  additionalDetails,
}) {
  console.log("transferDetails============", transferDetails);
  const [summaryDetails, setSummaryDetails] = useState({});
  const configVariables = useSelector((state) => state.config.baseConfig);
const handlePrintReceipt = () => {
    const transID = transferDetails.trngrpid; // ← use trngrpid

    if (!transID) return;

    let url = `${configVariables.baseURL}${configVariables.receiptExtension}/mod_genreceipt.php?type=internationaltransfer&id=${transID}`;

    if (service === "MoneyGram") {
        url += "&moneygram=1";
    }

    window.open(url, "_blank");
};
  //TODO standardize these across RIA, Emerlink, and future integrations
  //Was originally designed when RIA and Emerlink were completely separate, so a standard must be set for
  //future integrations at minimum where only differing response data might need to be pulled
  useEffect(() => {
    if (service === "RIA" && type === "send") {
      let customerName = `${user.User.firstName} ${user.User.lastName}`;
      let counterPartyName = `${transferDetails.rfirstname} ${transferDetails.rlastname}`;
      setSummaryDetails({
        customerName: `${decodeHtmlEntities(customerName)}`,
        counterPartyName: `${decodeHtmlEntities(counterPartyName)}`,
        receiverCountry: transferDetails.receiveCountry,
        amount: parseFloat(transferDetails.ramount).toFixed(2),
        fee: parseFloat(transferDetails.servicefee).toFixed(2),
        adminFee: parseFloat(transferDetails.feeconsumertotal).toFixed(2),
        tax: parseFloat(transferDetails.taxamount).toFixed(2),
        totalAmount: parseFloat(transferDetails.totalamount).toFixed(2),
        receiverPhone: transferDetails.receiverPhone,
        receiverEmail: transferDetails.receiverEmail,
        transactionID: transferDetails.riaPIN,
        subtotal: (
          parseFloat(transferDetails.ramount) +
          parseFloat(transferDetails.servicefee) +
          parseFloat(transferDetails.taxamount)
        ).toFixed(2),
      });
    } else if (service === "RIA" && type === "receive") {
      let customerName = `${user.User.firstName} ${user.User.lastName}`;
      let counterPartyName = `${transferDetails.CustNameFirst} ${transferDetails.CustNameLast1}`;
      setSummaryDetails({
        customerName: `${decodeHtmlEntities(customerName)}`,
        counterPartyName: `${decodeHtmlEntities(counterPartyName)}`,
        receiverCountry: transferDetails.receiveCountry,
        amount: parseFloat(transferDetails.BeneAmount).toFixed(2),
        totalAmount: parseFloat(transferDetails.BeneAmount).toFixed(2),
        receiverPhone: transferDetails?.receiverPhone,
        receiverEmail: transferDetails?.receiverEmail,
        transactionID: transferDetails?.riapin,
      });
    } else if (service === "BPI") {
      let customerName = `${user.User.firstName} ${user.User.lastName}`;
      let counterPartyName = `${transferDetails.beneficiaryFirstName} ${transferDetails?.beneficiaryMiddleName || ""} ${transferDetails.beneficiaryLastName}`;
      setSummaryDetails({
        customerName: `${decodeHtmlEntities(customerName)}`,
        counterPartyName: `${decodeHtmlEntities(counterPartyName)}`,
        receiverCountry: transferDetails.beneficiaryNationality,
        amount: parseFloat(transferDetails.amount).toFixed(2),
        transactionID: transferDetails.transactionID,
        fee: parseFloat(transferDetails.transferFees).toFixed(2),
        adminFee: parseFloat(transferDetails.adminFees).toFixed(2),
        tax: parseFloat(transferDetails.taxes).toFixed(2),
        subtotal: (
          parseFloat(transferDetails.amount) +
          parseFloat(transferDetails.transferFees) +
          parseFloat(transferDetails.taxes)
        ).toFixed(2),
        totalAmount: parseFloat(transferDetails.totalAmount).toFixed(2),
        recipientcurrencycode: transferDetails?.recipientcurrencycode,
        recipientamount: parseFloat(transferDetails.recipientamount).toFixed(2),
        exchangerate: parseFloat(transferDetails.exchangerate).toFixed(2),
        exchangeRate: parseFloat(transferDetails.exchangerate).toFixed(2),
        expectedAmount: parseFloat(transferDetails.recipientamount).toFixed(2),
        onhold: transferDetails.onhold,
        onholdmsg: transferDetails.onholdmsg,
      });
    } else if (service === "WesternUnion" && type === "send") {
      let customerName = `${user.User.firstName} ${user.User.lastName}`;
      let counterPartyName = `${transferDetails.receiverName}`;
      setSummaryDetails({
        customerName: `${decodeHtmlEntities(customerName)}`,
        counterPartyName: `${decodeHtmlEntities(counterPartyName)}`,
        receiverCountry: transferDetails.receivercountry,
        amount: parseFloat(transferDetails.consumerSendAmount).toFixed(2),
        transactionID: transferDetails.transactionID,
        fee: parseFloat(transferDetails.servicefee).toFixed(2),
        tax: parseFloat(transferDetails.taxamount).toFixed(2),
        totalAmount: parseFloat(transferDetails.totalamount).toFixed(2),
        expectedAmount: `${transferDetails.receivercurrency} ${parseFloat(transferDetails.expectedPayoutAmt).toFixed(2)}`,
        exchangeRate: `${transferDetails.exchangeRate}`,
        adminFee: parseFloat(transferDetails.convenienceFee).toFixed(2),
        subtotal: (
          parseFloat(transferDetails.consumerSendAmount) +
          parseFloat(transferDetails.servicefee) +
          parseFloat(transferDetails.taxamount)
        ).toFixed(2),
        // convenienceFee: parseFloat(transferDetails.convenienceFee).toFixed(2)
      });
    } else if (service === "WesternUnion" && type === "receive") {
      let customerName = `${user.User.firstName} ${user.User.lastName}`;
      let counterPartyName = `${transferDetails.senderName}`;
      setSummaryDetails({
        customerName: `${decodeHtmlEntities(customerName)}`,
        counterPartyName: `${decodeHtmlEntities(counterPartyName)}`,
        receiverCountry: transferDetails.receivercountry,
        amount: parseFloat(transferDetails.amount).toFixed(2),
        transactionID: transferDetails.transactionID,
        totalAmount: parseFloat(transferDetails.amount).toFixed(2),
      });
    } else if (service === "MoneyGram" && type === "send") {
      let customerName = `${user.User.firstName} ${user.User.lastName}`;
      let counterPartyName = `${transferDetails.receiverFirstName} ${transferDetails.receiverLastName}`;

      let deliveryOpt = {};
      let showDisclaimer = false;
      let receiveAmountToShow = null;
      let exchangeRateToShow = null;
      let receiveCurrencyToShow = "USD"; // Fallback
      let deliveryOptionToShow = "N/A";
      let accountNumberToShow = transferDetails.accountNumber || null;
      let agentLocation = null;
      let agentId = null;
      let showWillCallMessage = false; // ← ADDED

      console.log(
        "transferdetails before even setting enything",
        transferDetails.totalAmountToCollect,
      );

      try {
        const outer = transferDetails.deliveryoption
          ? JSON.parse(transferDetails.deliveryoption)
          : {};
        deliveryOpt = typeof outer === "string" ? JSON.parse(outer) : outer;
        console.log("Parsed deliveryOpt:", deliveryOpt);
        deliveryOptionToShow = deliveryOpt.deliveryOption || "N/A";

        console.log(
          "valid currency indicator is false",
          deliveryOpt.receiveAmounts.validCurrencyIndicator,
        );

        // Check validCurrencyIndicator to decide estimated vs valid
        if (deliveryOpt.receiveAmounts.validCurrencyIndicator === "false") {
          console.log("valid currency indicator is false");
          showDisclaimer = true; // Trigger disclaimer
          receiveAmountToShow = deliveryOpt.estimatedReceiveAmount
            ? parseFloat(deliveryOpt.estimatedReceiveAmount).toFixed(2)
            : null;
          exchangeRateToShow = deliveryOpt.estimatedExchangeRate
            ? parseFloat(deliveryOpt.estimatedExchangeRate).toFixed(2)
            : null;
          receiveCurrencyToShow = deliveryOpt.estimatedReceiveCurrency || "USD";
        } else {
          receiveAmountToShow = deliveryOpt.validReceiveAmount
            ? parseFloat(deliveryOpt.validReceiveAmount).toFixed(2)
            : null;
          exchangeRateToShow = deliveryOpt.validExchangeRate
            ? parseFloat(deliveryOpt.validExchangeRate).toFixed(2)
            : null;
          receiveCurrencyToShow = deliveryOpt.validReceiveCurrency || "USD";
        }

        if (deliveryOpt.deliveryOption === "WILLCALL_TO") {
          agentLocation = deliveryOpt.receiveAgentName || null;
          agentId = deliveryOpt.receiveAgentID || null;
          showWillCallMessage = true; // ← ADDED
        }
      } catch (e) {
        console.warn("Failed to parse MoneyGram deliveryoption", e);
      }

      console.log(
        "total amount during setting details",
        parseFloat(transferDetails.totalAmountToCollect).toFixed(2),
      );

      setSummaryDetails({
        customerName: `${decodeHtmlEntities(customerName)}`,
        counterPartyName: `${decodeHtmlEntities(counterPartyName)}`,
        receiverCountry: transferDetails.receivercountry,
        fee: parseFloat(transferDetails.fees).toFixed(2),
        tax: parseFloat(transferDetails.taxes).toFixed(2),
        amount: parseFloat(transferDetails.amount).toFixed(2),
        transactionID: transferDetails.confcode,
        totalAmount: parseFloat(transferDetails.totalAmountToCollect).toFixed(
          2,
        ),
        adminFee: parseFloat(transferDetails.adminFees).toFixed(2),
        subtotal: (
          parseFloat(transferDetails.amount) +
          parseFloat(transferDetails.fees) +
          parseFloat(transferDetails.taxes)
        ).toFixed(2),
        validReceiveAmount: receiveAmountToShow,
        validExchangeRate: exchangeRateToShow,
        showDisclaimer: showDisclaimer,
        receiveCurrency: receiveCurrencyToShow,
        deliveryOption: deliveryOptionToShow,
        accountNumber: accountNumberToShow,
        agentLocation: agentLocation,
        agentId: agentId,
        showWillCallMessage: showWillCallMessage, // ← ADDED
      });
    } else if (service === "MoneyGram" && type === "receive") {
      let customerName = `${user.User.firstName} ${user.User.lastName}`;
      let counterPartyName = `${transferDetails.senderName}`;
      let deliveryOpt = {};
      let showDisclaimer = false;
      let receiveAmountToShow = null;
      let exchangeRateToShow = null;
      let receiveCurrencyToShow = "USD";
      let deliveryOptionToShow = "N/A";
      let accountNumberToShow = transferDetails.accountNumber || null;
      let agentLocation = null;
      let agentId = null;
      let showWillCallMessage = false; // ← ADDED

      try {
        const outer = transferDetails.deliveryoption
          ? JSON.parse(transferDetails.deliveryoption)
          : {};
        deliveryOpt = typeof outer === "string" ? JSON.parse(outer) : outer;
        deliveryOptionToShow = deliveryOpt.deliveryOption || "N/A";

        if (deliveryOpt.validCurrencyIndicator === "false") {
          showDisclaimer = true;
          receiveAmountToShow = deliveryOpt.estimatedReceiveAmount
            ? parseFloat(deliveryOpt.estimatedReceiveAmount).toFixed(2)
            : null;
          exchangeRateToShow = deliveryOpt.estimatedExchangeRate
            ? parseFloat(deliveryOpt.estimatedExchangeRate).toFixed(2)
            : null;
          receiveCurrencyToShow = deliveryOpt.estimatedReceiveCurrency || "USD";
        } else {
          receiveAmountToShow = deliveryOpt.validReceiveAmount
            ? parseFloat(deliveryOpt.validReceiveAmount).toFixed(2)
            : null;
          exchangeRateToShow = deliveryOpt.validExchangeRate
            ? parseFloat(deliveryOpt.validExchangeRate).toFixed(2)
            : null;
          receiveCurrencyToShow = deliveryOpt.validReceiveCurrency || "USD";
        }

        if (deliveryOpt.deliveryOption === "WILLCALL_TO") {
          agentLocation = deliveryOpt.receiveAgentName || null;
          agentId = deliveryOpt.receiveAgentID || null;
          showWillCallMessage = true; // ← ADDED
        }
      } catch (e) {
        console.warn("Failed to parse MoneyGram deliveryoption", e);
      }
      setSummaryDetails({
        customerName: `${decodeHtmlEntities(customerName)}`,
        counterPartyName: `${decodeHtmlEntities(counterPartyName)}`,
        receiverCountry: transferDetails.originatingCountry || "N/A",
        amount: parseFloat(transferDetails.amount).toFixed(2),
        totalAmount: parseFloat(transferDetails.amount).toFixed(2),
        transactionID: transferDetails.referencenumber,
        receiveCurrency: transferDetails.receiveCurrency || "N/A",
        originalSendAmount: parseFloat(
          transferDetails.originalSendAmount,
        ).toFixed(2),
        originalSendCurrency: transferDetails.originalSendCurrency || "N/A",
        deliveryOption: transferDetails.deliveryOption || "N/A",
        expectedDateOfDelivery: transferDetails.expectedDateOfDelivery || "N/A",
        sendPurposeOfTransaction:
          transferDetails.sendPurposeOfTransaction || "N/A",
        redirectIndicator: transferDetails.redirectIndicator === "true",
        deliveryOption: deliveryOptionToShow,
        accountNumber: accountNumberToShow,
        indicativeExchangeRate: transferDetails.indicativeExchangeRate
          ? parseFloat(transferDetails.indicativeExchangeRate).toFixed(2)
          : null,
        indicativeReceiveAmount: transferDetails.indicativeReceiveAmount
          ? parseFloat(transferDetails.indicativeReceiveAmount).toFixed(2)
          : null,
        validReceiveAmount: receiveAmountToShow,
        validExchangeRate: exchangeRateToShow,
        showDisclaimer: showDisclaimer,
        receiveCurrency: receiveCurrencyToShow,
        agentLocation: agentLocation,
        agentId: agentId,
        showWillCallMessage: showWillCallMessage, // ← ADDED
      });
    }
  }, []);

  return (
    <Box className="w-75 mx-auto">
      {service == "BPI" ? (
        <Box display="flex" justifyContent="center" className="mt-3 fs-4">
          Transaction{" "}
          {isReceipt
            ? transferDetails?.onhold == "1"
              ? "is on hold"
              : "Completed"
            : "Summary"}
        </Box>
      ) : (
        <Box display="flex" justifyContent="center" className="mt-3 fs-4">
          Transaction {isReceipt ? "Completed" : "Summary"}
        </Box>
      )}

      {(summaryDetails?.transactionID || type === "receive") && (
        <Box
          display="flex"
          justifyContent="center"
          className="text-muted fs-size-14"
        >
          Transaction ID: {summaryDetails.transactionID}
        </Box>
      )}

      <Box display="flex" justifyContent="space-between" className="mt-3">
        <Box>
          <Box className="fw-bold">Sender Details</Box>
          <Box>
            {type === "send"
              ? summaryDetails.customerName
              : summaryDetails.counterPartyName}
          </Box>
        </Box>

        <Box>
          <Box className="fw-bold">Receiver Details</Box>
          <Box>
            {type === "send"
              ? summaryDetails.counterPartyName
              : summaryDetails.customerName}
          </Box>
          <Box className="text-muted">
            <Box>{transferDetails.receiverPhone ?? ""}</Box>
            <Box>{transferDetails.receiverEmail ?? ""}</Box>
          </Box>
        </Box>
      </Box>

      <Box className="mt-4" sx={{ backgroundColor: "#F8F8F8" }}>
        <Box
          display="flex"
          justifyContent="space-between"
          className="mt-2 px-2"
        >
          <Box>{type === "send" ? "Send" : "Receive"} Date</Box>
          <Box>{new Date().toDateString()}</Box>
        </Box>

        {summaryDetails.receiverCountry && (
          <Box
            display="flex"
            justifyContent="space-between"
            className="mt-2 px-2"
          >
            <Box>Destination Country</Box>
            <Box>{summaryDetails.receiverCountry}</Box>
          </Box>
        )}

        {summaryDetails.deliveryOption &&
          service === "MoneyGram" &&
          type === "receive" && (
            <Box
              display="flex"
              justifyContent="space-between"
              className="mt-2 px-2"
            >
              <Box>Delivery Option</Box>
              <Box>{summaryDetails.deliveryOption}</Box>
            </Box>
          )}

        {summaryDetails.expectedDateOfDelivery &&
          service === "MoneyGram" &&
          type === "receive" && (
            <Box
              display="flex"
              justifyContent="space-between"
              className="mt-2 px-2"
            >
              <Box>Expected Delivery Date</Box>
              <Box>{summaryDetails.expectedDateOfDelivery}</Box>
            </Box>
          )}

        {summaryDetails.sendPurposeOfTransaction &&
          service === "MoneyGram" &&
          type === "receive" && (
            <Box
              display="flex"
              justifyContent="space-between"
              className="mt-2 px-2"
            >
              <Box>Purpose of Transaction</Box>
              <Box>{summaryDetails.sendPurposeOfTransaction}</Box>
            </Box>
          )}

        {summaryDetails.redirectIndicator && service === "MoneyGram" && (
          <Box
            sx={{
              mt: 2,
              p: 2,
              border: "1px solid #ccc",
              borderRadius: "4px",
              backgroundColor: "#FFF3E0",
            }}
          >
            <Box className="fw-bold" sx={{ color: "#F57C00" }}>
              Currency Redirect Transaction
            </Box>
            <Box
              display="flex"
              justifyContent="space-between"
              className="mt-2 px-2"
            >
              <Box>Exchange Rate</Box>
              <Box>{summaryDetails.indicativeExchangeRate || "N/A"}</Box>
            </Box>
            <Box
              display="flex"
              justifyContent="space-between"
              className="mt-2 px-2"
            >
              <Box>Indicative Receive Amount</Box>
              <Box>
                {summaryDetails.indicativeReceiveAmount
                  ? `${summaryDetails.indicativeReceiveAmount} ${summaryDetails.receiveCurrency}`
                  : "N/A"}
              </Box>
            </Box>
          </Box>
        )}

        {additionalDetails &&
          additionalDetails.map(({ label, value }) => (
            <Box
              key={label}
              display="flex"
              justifyContent="space-between"
              className="mt-2 px-2"
            >
              <Box>{label}</Box>
              <Box>{value}</Box>
            </Box>
          ))}

        <Box
          display="flex"
          justifyContent="space-between"
          className="mt-2 px-2"
        >
          <Box>
            {type === "receive" ? "Original Send Amount" : "Send Amount"}
          </Box>
          <Box>
            {type === "receive" && service === "MoneyGram"
              ? `${summaryDetails.originalSendAmount} ${summaryDetails.originalSendCurrency}`
              : `$${summaryDetails.amount}`}
          </Box>
        </Box>

        {summaryDetails.expectedAmount && (
          <Box
            display="flex"
            justifyContent="space-between"
            className="mt-2 px-2"
          >
            <Box>Expected Amount</Box>
            <Box>{summaryDetails.expectedAmount}</Box>
          </Box>
        )}

        {summaryDetails.exchangeRate && (
          <Box
            display="flex"
            justifyContent="space-between"
            className="mt-2 px-2"
          >
            <Box>Exchange Rate</Box>
            <Box>{summaryDetails.exchangeRate}</Box>
          </Box>
        )}

        {summaryDetails?.fee && (
          <Box
            display="flex"
            justifyContent="space-between"
            className="mt-2 px-2"
          >
            <Box>Transfer Fees</Box>
            <Box>${summaryDetails.fee}</Box>
          </Box>
        )}

        {summaryDetails?.tax && (
          <Box
            display="flex"
            justifyContent="space-between"
            className="mt-2 px-2"
          >
            <Box>DFSST</Box>
            <Box>${summaryDetails.tax}</Box>
          </Box>
        )}

        {summaryDetails?.subtotal && (
          <Box
            display="flex"
            justifyContent="space-between"
            className="mt-2 px-2"
          >
            <Box>Sub Total Amount</Box>
            <Box>${summaryDetails.subtotal}</Box>
          </Box>
        )}
        {summaryDetails.deliveryOption && service === "MoneyGram" && (
          <Box
            display="flex"
            justifyContent="space-between"
            className="mt-2 px-2"
          >
            <Box>Delivery Option</Box>
            <Box>{summaryDetails.deliveryOption}</Box>
          </Box>
        )}

        {summaryDetails.accountNumber &&
          service === "MoneyGram" &&
          summaryDetails.accountNumber !== null && (
            <Box
              display="flex"
              justifyContent="space-between"
              className="mt-2 px-2"
            >
              <Box>Account Number</Box>
              <Box>{summaryDetails.accountNumber}</Box>
            </Box>
          )}

        {summaryDetails?.adminFee && (
          <Box
            display="flex"
            justifyContent="space-between"
            className="mt-2 px-2"
          >
            <Box>Digital Account Fee</Box>
            <Box>${summaryDetails.adminFee}</Box>
          </Box>
        )}

        {service === "MoneyGram" &&
          summaryDetails?.validReceiveAmount &&
          parseFloat(summaryDetails.validReceiveAmount) > 0 && (
            <Box
              display="flex"
              justifyContent="space-between"
              className="mt-2 px-2"
            >
              <Box>Total Receive Amount</Box>
              <Box>
                {summaryDetails.validReceiveAmount}{" "}
                {summaryDetails.receiveCurrency}
              </Box>
            </Box>
          )}
        {service === "MoneyGram" &&
          summaryDetails?.validExchangeRate &&
          parseFloat(summaryDetails.validExchangeRate) > 0 && (
            <Box
              display="flex"
              justifyContent="space-between"
              className="mt-2 px-2"
            >
              <Box>Exchange Rate Applied</Box>
              <Box>{summaryDetails.validExchangeRate}</Box>
            </Box>
          )}
        {summaryDetails.showDisclaimer && service === "MoneyGram" && (
          <Box
            sx={{
              mt: 2,
              p: 2,
              border: "1px solid #ccc",
              borderRadius: "4px",
              backgroundColor: "#FFF3E0",
            }}
          >
            <Box className="fw-bold" sx={{ color: "#F57C00" }}>
              Exchange Rate Notice
            </Box>
            <Box
              className="mt-2 px-2"
              sx={{
                fontSize: "0.875rem",
                color: "#E65100",
                fontStyle: "italic",
              }}
            >
              The above exchange rate is only an approximation. The actual
              exchange rate will be the rate that is in effect at the time the
              transfer is received.
            </Box>
          </Box>
        )}

        {summaryDetails?.totalAmount && (
          <Box
            display="flex"
            justifyContent="space-between"
            className="fw-bold my-2 px-2"
          >
            <Box>Withdrawal Amount</Box>
            <Box>${summaryDetails.totalAmount}</Box>
            {console.log(
              "total amlount in summary",
              summaryDetails.totalAmount,
            )}
          </Box>
        )}

        {summaryDetails.agentLocation && service === "MoneyGram" && (
          <>
            <Box
              display="flex"
              justifyContent="space-between"
              className="mt-2 px-2"
            >
              <Box>Cash Pickup Location</Box>
              <Box>{summaryDetails.agentLocation}</Box>
            </Box>
            {summaryDetails.agentId && (
              <Box
                display="flex"
                justifyContent="space-between"
                className="mt-2 px-2"
              >
                <Box>Agent ID</Box>
                <Box>{summaryDetails.agentId}</Box>
              </Box>
            )}

            {/* ← ADDED: WILLCALL_TO message */}
            {summaryDetails.showWillCallMessage && (
              <Box
                className="mt-3 px-2"
                sx={{
                  fontSize: "0.875rem",
                  fontStyle: "italic",
                  color: "#666",
                }}
              >
                Funds will be available at select locations. Inform your
                receiver where to collect their money.
              </Box>
            )}
          </>
        )}
      </Box>

      <Box>
        <InternationalTransferFooterButtons
          buttonOneText={isReceipt ? "Return to Dashboard" : "Cancel"}
          buttonTwoText={type === "send" ? "Send Money" : "Receive Money"}
          handleButtonOne={handleReturn}
          handleButtonTwo={handleContinue}
          showButtonTwo={!isReceipt}
          showMiddleButton={type === "send" && !isReceipt}
          middleButtonText={contactButtonText}
          handleMiddleButton={handleSaveContact}
          disableMiddleButton={disableSaveContact}
          showPrintReceipt={isReceipt}
          handlePrintReceipt={handlePrintReceipt} // ← ADD
        />
      </Box>
    </Box>
  );
}

export default InternationalTransferSummary;
